import Accordion from '@/common/components/Accordion'
import { UpdateFiscalDetailsModal } from '@/features/privateCompanies/components/updateContract/UpdateFiscalDetailsModal'
import { CompanyContractType } from '@/features/privateCompanies/types/companyContract.type'
import { strategy as fiscalDocumentConsumerStrategy } from '@/features/privateCompanyLeadsFunnel/constants/fiscalDocumentConsumer.constant'
import { strategy as fiscalDocumentRequirementStrategy } from '@/features/privateCompanyLeadsFunnel/constants/fiscalDocumentRequirement.constant'
import { CircleChevronDownIcon } from 'lucide-react'

type FiscalDetailsProps = {
  contract?: CompanyContractType
}

export const FiscalDetails = ({ contract }: FiscalDetailsProps) => {
  return (
    <Accordion
      defaultOpen
      name="fiscal_details"
      head={
        <div className="flex items-center gap-x-2">
          <div onClick={(e) => e.stopPropagation()}>
            <UpdateFiscalDetailsModal contract={contract} />
          </div>

          <p className="text-white-800">Detalhes Fiscais</p>
        </div>
      }
      triggerClassName="py-0"
      bodyClassName="pt-4 pb-0"
      body={
        <div className="flex flex-col gap-y-4">
          <div className="flex items-center gap-x-2">
            <p className="text-[11px] leading-3 text-white-800">Tipo de recolha:</p>

            <div className="flex items-center gap-x-1">
              <CircleChevronDownIcon strokeWidth={1} className="size-5 text-white-400" />

              <p data-testid="contract_fiscal_document_requirement" className="text-xs text-white-400">
                {contract?.fiscal_document_requirement
                  ? fiscalDocumentRequirementStrategy[
                      contract.fiscal_document_requirement as keyof typeof fiscalDocumentRequirementStrategy
                    ]
                  : '--'}
              </p>
            </div>
          </div>

          <div className="flex items-center gap-x-2">
            <p className="text-[11px] leading-3 text-white-800">CNPJ p/ coleta de nota fiscal:</p>

            <div className="flex items-center gap-x-1">
              <CircleChevronDownIcon strokeWidth={1} className="size-5 text-white-400" />

              <p data-testid="contract_fiscal_document_consumer" className="text-xs text-white-400">
                {contract?.fiscal_document_consumer
                  ? fiscalDocumentConsumerStrategy[
                      contract.fiscal_document_consumer as keyof typeof fiscalDocumentConsumerStrategy
                    ]
                  : '--'}
              </p>
            </div>
          </div>
        </div>
      }
    />
  )
}
